import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'


// global pluginst
import './plugins'

// Helper
import Helper from './helpers/helper'


// Directives
import globalDirectives from './directives';

Vue.use(globalDirectives);

/**
 * Network status listner
 * this will checked or listen to network connection
 */

/**
 * Check network status connection on load
 */
//  if (navigator.onLine) {
//   store.commit('updatenetworkstatus', true);
// } else {
//   store.commit('updatenetworkstatus', false);
// }
/**
 * Check network status connection on load
 */
 fetch('https://picsum.photos/id/237/200/300').then(() => {
  store.commit('updatenetworkstatus', true);
}).catch(() => {
  store.commit('updatenetworkstatus', false);
})

/**
 * Listen network status
 */
window.addEventListener('offline', () =>  { 
  store.commit('updatenetworkstatus', false);
});

window.addEventListener('online', () => { 
  store.commit('updatenetworkstatus', true);
});

if(process.env.NODE_ENV.trim() != 'development') {
  console.log = function() {}
}


/**
 * Configs
 */
Vue.config.productionTip = false
Helper.axoisglobalconfig();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
